import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import Meta from "vue-meta"
import VueAnalytics from "vue-analytics"

const requireComponent = require.context("./components/elements", false, /[\w-]+\.vue$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1")
  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === "production"
Vue.use(Meta)
Vue.use(VueAnalytics, {
  id: "UA-129663733-1",
  router,
  autoTracking: {
    pageviewOnLoad: false
  },
  debug: {
    enabled: false,
    sendHitTask: isProd
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
